import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkDayState } from '../reducers';

export const selectWorkDayState = createFeatureSelector<WorkDayState>('workDay');

export const selectWorkDayLoading = createSelector(selectWorkDayState,(state: WorkDayState) => state.loading);

export const selectWorkDay = createSelector(selectWorkDayState,(state: WorkDayState) => state.workDay);

export const selectWorkDayError = createSelector(selectWorkDayState,(state: WorkDayState) => state.error);
